/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SearchResponse } from '../models/SearchResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SearchService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Search for results
     * Searches for resources by query, country and language
     * @returns SearchResponse Ok
     * @throws ApiError
     */
    public search({
        query,
        country = 'us',
        language = 'en',
        pageNumber = 1,
    }: {
        query: string,
        country?: string,
        language?: string,
        pageNumber?: number,
    }): CancelablePromise<SearchResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/search',
            query: {
                'query': query,
                'country': country,
                'language': language,
                'pageNumber': pageNumber,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Submit click feedback for a result
     * Searches for resources by query, country and language
     * @returns any Accepted
     * @throws ApiError
     */
    public searchClickFeedback({
        resultId,
        queryId,
    }: {
        resultId: string,
        queryId: string,
    }): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/search-click-feedback',
            query: {
                'resultId': resultId,
                'queryId': queryId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

}
